export default "__VITE_ASSET__BhFY8z8e__"